import Swal from "sweetalert2";
import Cookies from "js-cookie";
import api from "../../services/api";

// EXCLUIR ENFERMEIROS
export function useExcluirEnfermeiros({
  searchTerm,
  limit,
  currentPage,
  fetchDataCache,
  setTotalItems,
}) {
  const excluirSelecionados = async (selectedItems, setSelectedItems) => {
    if (!Array.isArray(selectedItems) || selectedItems.length === 0) return;

    const result = await Swal.fire({
      html: `
    <div class="swal-exclusao-content">

      <div class="swal-exclusao-question">
        !
      </div>

      <div class="swal-exclusao-heading">
        Tem certeza?
      </div>

      <p class="swal-exclusao-subtitle">
        Você está prestes a excluir
        <strong>${selectedItems.length} enfermeiro(s)</strong>:
      </p>

      <div class="swal-exclusao-info">
        ${selectedItems
          .map(
            (i) => `
              <div class="swal-exclusao-item">

                <div class="swal-exclusao-row">
                  <span>Nome</span>
                  <strong>${i.nome || "-"}</strong>
                </div>

                <div class="swal-exclusao-row">
                  <span>CPF</span>
                  <strong>${i.cpf || "-"}</strong>
                </div>

                <div class="swal-exclusao-row">
                  <span>Empresa</span>
                  <strong>
                    ${i.marcador_razao_social ??
              i.razao_social ??
              "Nenhuma Razão Social Encontrada..."
              }
                  </strong>
                </div>

              </div>
            `
          )
          .join("")}
      </div>

    </div>
  `,

      showCancelButton: true,

      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar",

      reverseButtons: true,

      buttonsStyling: false,

      customClass: {
        popup: "swal-exclusao-popup",
        htmlContainer: "swal-exclusao-html",
        actions: "swal-exclusao-actions",
        confirmButton: "swal-exclusao-confirm",
        cancelButton: "swal-exclusao-cancel",
      },
    });

    if (!result.isConfirmed) return;

    const inicio = Date.now();

    try {
      /* LOADING */
      /* LOADING PREMIUM PADRÃO */
      Swal.fire({
        html: `
    <div class="swal-loading-content">

      <div class="swal-loading-spinner swal-loading-spinner-danger"></div>

      <div class="swal-loading-heading">
        Excluindo enfermeiro(s)
      </div>

      <div class="swal-loading-text">
        Processando a exclusão no sistema...
      </div>

    </div>
  `,

        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,

        customClass: {
          popup: "swal-loading-popup",
          htmlContainer: "swal-loading-html",
        },
      });

      await Promise.all(
        selectedItems.map((item) =>
          api.put(
            `/enfermeiros/${item.id}`,
            {
              ativo: item.id,
              awsd: "rKhRtfN/nhV4ExudS1OoNqEfJ0B2KsOD8",
              apagado_por: localStorage.getItem("clientID"),
            },
            {
              headers: { typo: localStorage.getItem("id") },
            }
          )
        )
      );

      /* TEMPO MÍNIMO */
      const tempoMinimo = 2000;
      const tempoPassado = Date.now() - inicio;

      if (tempoPassado < tempoMinimo) {
        await new Promise((resolve) =>
          setTimeout(resolve, tempoMinimo - tempoPassado)
        );
      }

      Swal.close();
      await Swal.fire({
        html: `
    <div class="swal-sucesso-content">

      <div class="swal-sucesso-icon">
        ✓
      </div>

      <div class="swal-sucesso-title">
        Excluído!
      </div>

      <div class="swal-sucesso-text">
        Enfermeiros excluídos com sucesso.
      </div>

    </div>
  `,

        timer: 1800,
        timerProgressBar: true,

        showConfirmButton: false,

        customClass: {
          popup: "swal-sucesso-popup",
          htmlContainer: "swal-sucesso-html",
          timerProgressBar: "swal-sucesso-progress",
        },
      });
      setSelectedItems([]);

      const { data } = await api.get(
        `/totalenfermeiro?searchTerm=${searchTerm}`,
        {
          headers: { typo: localStorage.getItem("id") },
        }
      );

      setTotalItems(data.result);
      await fetchDataCache(limit, currentPage);

    } catch (error) {
      Swal.close();

      Swal.fire({
        icon: "error",
        title: "Erro",
        text:
          error?.response?.data?.message ||
          error?.response?.data?.mensagem ||
          "Erro ao excluir enfermeiros selecionados.",

        background: "#0f172a",
        color: "#fff",
      });
    }
  };

  return { excluirSelecionados };
}